const E = {
  'Thank you for your order': 'Thank you for your order.',
  'Your confirmation number is': 'Your confirmation number is',
  'Order Summary': 'Order Summary',
  Finished: 'Finished',
  'eCOC Terms and Conditions': 'eCOC Terms and Conditions',
  'Thank you for your submission': 'Thank you for your submission.',
  'Your eCOC confirmation number is': 'Your eCOC confirmation number is',
  ImportantNumber: 'Don\'t forget me, I\'m an important number!',
  'Please record the eCOC number on your cooler and on your Custody Tracking Form or print a pre-populated form using the Tracking Form button below': 'Please record the eCOC number on your cooler and on your Custody Tracking Form or print a pre-populated form using the Tracking Form button below.',
  'Submission Summary': 'Submission Summary',
  'Submission Details': 'Submission Details',
  'Tracking Form': 'Tracking Form',
  'Back to Jobs': 'Back to Jobs',
  'Back to Orders': 'Back to Orders',
  Submission: 'Submission',
  Order: 'Order',
};

const F = {
  'Thank you for your order': 'Nous vous remercions de votre commande',
  'Your confirmation number is': 'Voici votre numéro de confirmation',
  'Order Summary': 'Résumé de la commande',
  Finished: 'Terminé',
  'eCOC Terms and Conditions': 'Conditions générales de l’eCDR',

  'Thank you for your submission': 'Merci pour votre envoi.',
  'Your eCOC confirmation number is': 'Voici votre numéro de confirmation',
  ImportantNumber: 'Notez-moi quelque part, vous aurez besoin de moi !',
  'Please record the eCOC number on your cooler and on your Custody Tracking Form or print a pre-populated form using the Tracking Form button below': 'Veuillez inscrire le numéro d’eCDR sur votre glacière et formulaire de référence de suivi ou imprimez un formulaire prérempli à l’aide du bouton Formulaire de référence de suivi ci-dessous.',
  'Submission Summary': 'Résumé de l’envoi ',
  'Submission Details': 'Détails de l’envoi',
  'Tracking Form': 'Formulaire de référence de suivi',

  'Back to Jobs': 'Revenir aux dossiers',
  'Back to Orders': 'Revenir aux commandes',
  Submission: 'Envoi',
  Order: 'Commande',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/confirmation.js